import React from "react";
import { Routes, Route } from "react-router-dom";
import SignUpForm from "./Pages/Signup";
import LoginForm from "./Pages/Login";
import Home from "./Pages/Home";
import User from "./Pages/User";
import Members from "./Pages/Members";
import UserProvider from "./Context/Userprovider";
import "./index.css";
import Sitebuilding from "./Components/Sitebuilding";
import About from "./Pages/About";
import Achievements from "./Pages/Achievements";
import Attendance from "./Pages/Attendance";
import Admin from "./Pages/Admin";

const App = () => {
  return (
    <UserProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignUpForm />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/members" element={<Members />} />
        <Route path="/about" element={<About />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/user/:id" element={<User />} />
        <Route path="*" element={<Sitebuilding />} />

        <Route path="/admin" element={<Admin />} />
      </Routes>
    </UserProvider>
  );
};

export default App;
